module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_5.9290962a.jpg";